import { render, staticRenderFns } from "./footerAddress.vue?vue&type=template&id=e0c3fff6&"
import script from "./footerAddress.vue?vue&type=script&lang=js&"
export * from "./footerAddress.vue?vue&type=script&lang=js&"
import style0 from "./footerAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports